import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteProjectFile } from '@/entities/project-file';

export { deleteProjectFile };

interface UseDeleteProjectFileOptions {
  projectId: string;
}

export function useDeleteProjectFile(options: UseDeleteProjectFileOptions) {
  const queryClient = useQueryClient();
  const { projectId } = options;

  return useMutation({
    mutationFn: (fileId: string) => deleteProjectFile(projectId, fileId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['project', projectId, 'folders'] });
      void queryClient.invalidateQueries({ queryKey: ['project', projectId, 'files'] });
    },
  });
}
